import "./error.page.scss";

const Error = ({ code = 404, message = "not found" }: ErrorProps) => {
  return (
    <div className="error-container">
      {code} {message.toUpperCase()}
    </div>
  );
};

export default Error;

interface ErrorProps {
  code?: number;
  message?: string;
}
